import React from "react";

function BlueMarkerIcon() {
    return (
        <svg width="32" height="38" viewBox="0 0 32 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d)">
                <path
                    d="M28 14.94C28 21.3108 22.9855 26.9806 16.6695 32.7409C16.2907 33.0864 15.7093 33.0864 15.3305 32.7409C9.0145 26.9806 4 21.3108 4 14.94C4 8.34574 9.37258 3 16 3C22.6274 3 28 8.34574 28 14.94Z"
                    fill="#504CF3"
                />
            </g>
            <path
                d="M20 14.94C20 17.1381 18.2091 18.92 16 18.92C13.7909 18.92 12 17.1381 12 14.94C12 12.7419 13.7909 10.96 16 10.96C18.2091 10.96 20 12.7419 20 14.94Z"
                fill="#D3D2FC"
            />
            <defs>
                <filter
                    id="filter0_d"
                    x="0"
                    y="0"
                    width="32"
                    height="38"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                    <feOffset dy="1" />
                    <feGaussianBlur stdDeviation="2" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
            </defs>
        </svg>
    );
}

export default BlueMarkerIcon;
